module.exports = __webpack_public_path__ + "static/media/sell_take_order_rent_1.ae95cf27.jpg";